import { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import { toNumberTag } from '../../utils/number';

import { Card, CardBody, Button } from "@windmill/react-ui";
import { useAccount, useNetwork, useWalletClient, useSwitchNetwork, useSendTransaction, useBalance } from 'wagmi'
import { parseEther } from 'viem'
import { getChainId } from '../../utils/connectors';
import { ethers, utils, BigNumber } from 'ethers'
import { useDispatch, useSelector } from '../../store';
import useApi from '../../hooks/useApi';
import { ChangePage } from '../../store/reducers/menu';
import { UpdateInfo } from '../../store/reducers/auth';
import {
    ChevronLeftIcon,
} from "../../icons";
import QRCode from "react-qr-code";
import toast, { Toaster } from "react-hot-toast";

import CopyToClipboard from 'react-copy-to-clipboard';
import { getCurrency } from "../../utils/Api";
import snackbar from "../../store/reducers/snackbar";


const ethereum = 'ether';

const DepositGateway = forwardRef(({ modalStyle, functions }, ref) => {
    const [amount, setAmount] = useState(0);
    const [showQR, setShowQR] = useState(false);
    const { balances } = useSelector((store) => store.auth);
    const dispatch = useDispatch();
    const { nowpayMinAmount } = useSelector((state) => state.auth);

    const [currency, setCurrency] = useState({});
    const [address, setAddress] = useState("");
    const { createNowpayments } = useApi();

    const createPayment = async () => {
        console.log(amount)

        try {
            createNowpayments(currency._id, currency.payment, amount)
                .then(({ data }) => {
                    if (data.pay_address) {
                        setAddress(data.pay_address)
                        setShowQR(true);
                    }
                })
                .catch((error) => {
                    console.log(error)
                });

        } catch (e) {
            console.log(e)
        }
    }

    const setNowCurrency = () => {
        if (balances.length > 0) {
            console.log("balances", balances)

            balances.map((item) => {
                if (item.status) {
                    setCurrency(item.currency);
                }
            });
        }
    }

    useEffect(() => {
        setNowCurrency();
    }, [balances]);

    return (
        <div id="gateway-modal"
            tabIndex={-1}
            style={{ backgroundColor: "rgba(22,22,22,0.8)" }}
            aria-hidden="true"
            className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-screen"
            data-modal-backdropclasses="bg-yellow-700">
            <div className="relative rounded-lg shadow w-full max-w-xl dark:bg-black">
                <button
                    type="button"
                    className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    data-modal-hide="login-modal"
                    onClick={() => {
                        dispatch(ChangePage(""))
                    }}
                >
                    <svg
                        className="w-3 h-3"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                    </svg>
                    <span className="sr-only">Close modal</span>
                </button>
                <div className="px-6 py-6 lg:px-8">
                    <div className="w-full grid grid-cols-1 mt-4">
                        <div className="flex items-start flex-col space-y-4 text-[#c7c7c7]">
                            {showQR ? (
                                <>
                                    <div className="flex flex-row justify-start items-center w-full space-x-2">
                                        <img src={currency.icon} className="w-6 h-6" />
                                        <p className="text-sm font-bold">Deposit {currency.name}</p>
                                    </div>
                                    <div className="grid grid-cols-1 w-full gap-5 mt-2">
                                        <div className='flex justify-center w-full'>
                                            <p className='text-center'>
                                                Send the amount of {currency.name} in the {currency.network} network to the
                                                following address to receive the equivalent in coins.
                                            </p>
                                        </div>
                                        <div className='flex justify-center'>
                                            <QRCode value={address} />
                                        </div>
                                        <div className='flex items-center justify-center gap-2 bg-gray bg-[#234322] border-[grey]'>
                                            <div>
                                                <p>⚠</p>
                                            </div>
                                            <div>
                                                <p>
                                                    Top-up addresses are one-time use only.
                                                </p>
                                                <p>
                                                    Don't reuse it, as your account won't be credited.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <p className='w-full text-center'>Your personal {currency.name} deposit address</p>
                                    <div className="w-full flex gap-2">
                                        <input
                                            type="text"
                                            id="address"
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            value={address}
                                            disabled
                                            readOnly
                                        ></input>
                                        <CopyToClipboard
                                            text={address}
                                            onCopy={() => toast.success("copied")}
                                        >
                                            <Button layout="outline">Copy
                                            </Button>
                                        </CopyToClipboard>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="flex flex-row justify-start items-center w-full space-x-2">
                                        <img src={currency.icon} className="w-6 h-6" />
                                        <p className="text-sm font-bold">Deposit {currency.name}</p>
                                    </div>
                                    <p>Minimum deposit amount:{nowpayMinAmount}</p>
                                    <p>Enter deposit amount:</p>
                                    <div className="w-full flex gap-2">
                                        <input
                                            type="text"
                                            id="amount"
                                            value={amount}
                                            onChange={(e) => {
                                                if (/^\d*\.?\d*$/.test(e.target.value)) {
                                                    setAmount(e.target.value);
                                                }
                                            }}
                                            className=" text-sm rounded-lg  block w-full p-2.5 dark:bg-primary text-white"
                                            placeholder="amount"
                                        ></input>
                                        <Button
                                            disabled={amount < 0 || amount < nowpayMinAmount}
                                            onClick={() => {
                                                if (amount > 0 && amount >= nowpayMinAmount) {
                                                    createPayment();
                                                }
                                            }}
                                            layout="outline"
                                        >
                                            Deposit
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default DepositGateway;
